export default "__VITE_ASSET__DsqlKqPI__"